import styled from "styled-components";

export const ArrangementSection = styled.section`
border-top: 1px solid rgba(229,238,238,.992);
border-bottom: 1px solid rgba(229,238,238,.992);
margin-top: 1.875rem;

.arrangement-section__content{
	margin-top: 3.75rem;
	

	& div {
		width: 49%;
		padding-left: 3.75rem;
		border-left: 4px solid rgb(7, 66, 117);
		height: 7.5rem;
		display: flex;
		align-items: center;
	}
}
`

export const FeaturesStockTradingSection = styled.section`

.top__content{
	& div{
		margin: 3.75rem 0rem;
	}
	& p{
	width: 48%;
	}
}
.cards{
& div {
	width: 32%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
}
`

export const ProsCostSection = styled.section`
background: #001b48;
color: #fff;

& h2{
	margin-bottom: 3.75rem;
}
& p{
margin: 1.25rem 0rem;
}

.pros-cost__cards{
margin-top: 3.75rem;
	& h4{
	color: #219453;
	}
	.red__title{
		color: #e95858;
	}
	& div {
		padding: 3.75rem;
		background-color: #fff;
		color: #000;
		width: 49%;
	}
	& span{
		display: inline-block;
		height: 5px;
		width: 1.875rem;
		background-color: #219453;
	}
	.red__span{
		background-color: #e95858;
	}
	& ul{
		margin-top: 5px;
	}
}
`

export const LinksSections = styled.section`

padding: 3.75rem 0rem;
border-top: 1px solid rgba(229,238,238,.992);
border-bottom: 1px solid rgba(229,238,238,.992);
margin-bottom: 40px;

.links-section__content{

	& div{
		width: 49%;
		background-color: #001b48;
		color: #fff;
		padding: 3.75rem;
	}
	& p{
		font-size: 1.25rem;
		font-weight: 700;
	}
	& a{
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: transparent;
		padding: 1.25rem;
		width: 11.25rem;
		border: 2px solid #fff;
		margin-top: 1.875rem;
		font-weight: 700;
	}
}
`

